import cn from 'classnames';

import * as st from './styles.module.scss';

interface Props {
	places: number;
	totalTickets?: number;
	handler?: () => void;
}

export const ButtonBuy = ({ places, totalTickets, handler }: Props): JSX.Element => {
	return (
		<>
			<>
				{!totalTickets ? (
					<button className={cn(st.button, st.active)} onClick={handler}>
						Участвовать
					</button>
				) : (
					<></>
				)}
			</>
		</>
	);
};

export default ButtonBuy;
